var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStarterPlan(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21 16.5C17.3668 19.9751 13.7335 28.5 13.7335 28.5C13.7335 28.5 11.1903 21.2702 6 18.501",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.5443 8.28653L30.1833 14.9223C30.5977 19.2272 27.37 23.06 23.0653 23.4746C18.8413 23.8812 15.015 20.7938 14.6082 16.5699C14.2015 12.3459 17.2959 8.59205 21.5199 8.18534L28.5951 7.50407C29.0733 7.45802 29.4982 7.80834 29.5443 8.28653Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarterPlan);
export default __webpack_public_path__ + "static/media/starter-plan.a24f5b592aa3e99c3e00d11f635b46c2.svg";
export { ForwardRef as ReactComponent };